import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Modal, Typography } from '@material-ui/core';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    gap: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: theme.spacing(3, 1),
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '95%',
    maxWidth: '900px',
  },
  title: {
    wordWrap: 'break-word',
    align: 'center',
    fontSize: 30,
  },
  tableWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

class ModalListaAttrezzatura extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: this.props.attrezzatureToRead,
      columns: [],
    };
  }

  componentDidMount = () => {
    let a = this.getColumnsForListaAttrezzatura();
    this.setState({
      columns: a,
    });
  };

  getColumnsForListaAttrezzatura = () => {
    return [
      {
        Header: 'Nome Attrezzatura',
        id: 'attrezzatura',
        accessor: (d) => d,
      },
    ];
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography className={classes.title}>
            Attrezzature associate al controllo conformità
          </Typography>
          <div className={classes.tableWrapper}>
            <ReactTable
              data={this.state.records}
              columns={this.state.columns}
              defaultPageSize={5}
              style={{ width: '90%' }}
              previousText="Precedente"
              nextText="Successivo"
              noDataText="Nessun record"
              pageText="Pagina"
              ofText="di"
              rowsText="righe"
              pageJumpText="Vai a pagina"
              rowsSelectorText="righe per pagina"
            />
          </div>
          <div>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={this.props.onClose}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalListaAttrezzatura.propTypes = {
  attrezzatureToRead: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ModalListaAttrezzatura);
